<template>
  <el-select v-model="current" size="mini" @change="onChange" style="width: 120px">
    <el-option label="中文 (zh)" value="zh" />
    <el-option label="English (en)" value="en" />
  </el-select>
</template>

<script>
import { currentLocale, setLocale } from '@/utils/locale'

export default {
  name: 'LanguageSwitcher',
  data() {
    return {
      current: 'zh'
    }
  },
  created() {
    this.current = currentLocale()
  },
  methods: {
    async onChange(val) {
      await setLocale(val)
      this.current = val
    }
  }
}
</script>

<style scoped>
</style>
